export default __webpack_public_path__ + "static/abound-de4e602d91e62f31ff06897b173995f7.svg";